export const EMAIL_REGEX = /.+@.+\..+/;

export const CUSTOMER_SEGMENTS = [
  { value: "retailer", label: "Retailer" },
  { value: "wholesale", label: "Wholesale" },
  { value: "hotel", label: "Hotel" },
  { value: "restaurant", label: "Restaurant" },
  { value: "event", label: "Event" },
  { value: "canteen", label: "Canteen" },
  { value: "family", label: "Family" }
];

